import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

function Datepicker({ options, onChange, value }) {
    const [refetch, setRefetch] = useState(false);

    useEffect(() => {
        if (refetch) onChange(refetch); //workaround in order to keep onchange callback updated in datepicker handler
        setRefetch(false);
    }, [onChange, refetch]);

    useEffect(() => {
        window.bronson
            .$$('#datepicker_' + options.id + '.js-datepicker')
            .on('bronson_datepickerChange', function (event) {
                setRefetch(event.detail.args[1]);
            });
    }, [options.id]);

    useEffect(() => {
        if (!value && document.getElementById(`${options.id}`).value) {
            /* Reset bronson datepicker when there's no value */
            document.getElementById(`${options.id}`).value = value;
        }
    }, [options.id, value]);

    const printComponent = () => {
        switch (options.type) {
            default:
                return (
                    <div className="c-form-field">
                        {options.label ? (
                            <label className="c-form-field__label">
                                {options.label}
                            </label>
                        ) : null}
                        <div className="c-form-field__box">
                            <div
                                id={'datepicker_' + options.id}
                                className="c-datepicker js-datepicker"
                                data-datepicker-date-format="d/m/Y"
                                data-datepicker-min-date={
                                    options.minDate ? options.minDate : ''
                                }
                                data-datepicker-max-date={
                                    options.maxDate ? options.maxDate : ''
                                }
                                data-datepicker-disable-mobile="true"
                            >
                                <div className="c-input">
                                    <input
                                        id={options.id}
                                        className="c-input__input"
                                        // onKeyDown={e => e.preventDefault()} //prevent user from typing manually a date
                                        type="text"
                                        value={value || undefined}
                                        autoComplete="off"
                                        disabled={options.disabled}
                                        data-input
                                        data-datepicker-disable-mobile="true"
                                    ></input>
                                    <button
                                        className="c-input__addon  c-input__addon--no-background"
                                        title="toggle"
                                        type="button"
                                        data-toggle
                                    >
                                        <i
                                            className="c-icon  c-icon--[semantic-calendar]"
                                            aria-hidden="true"
                                        ></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                );
        }
    };

    return <React.Fragment>{printComponent()}</React.Fragment>;
}

Datepicker.propTypes = {
    options: PropTypes.shape({
        label: PropTypes.string,
        type: PropTypes.string.isRequired,
        name: PropTypes.string,
        id: PropTypes.string.isRequired,
        className: PropTypes.string,
        disabled: PropTypes.bool,
    }).isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
};
export default Datepicker;
